import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  Content,
  Loading,
  LoadingController,
  Alert,
  AlertController,
  ViewController
} from "ionic-angular";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import { FirestoreProvider } from "../../providers/firestore/firestore";
import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";

import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import * as html2pdf from 'html2pdf.js';
import * as moment from 'moment';
import { AngularFireStorage, AngularFireUploadTask } from "angularfire2/storage";

@IonicPage()
@Component({
  selector: "page-survey",
  templateUrl: "survey.html"
})
export class SurveyPage {
  surveyresponse: FormGroup;

  signature: string = null;
  signatoryName: string = null;

  consentsignature: string = null;
  consentName: string = null;
  study_doctor_permission: any = "Yes"

  isDrawing = false;
  agree: boolean = false;
  doctor: any;
  patient: any;
  study: any;
  speedscore: number = 0;
  renewal: boolean = false;
  agreement: any;
  laststudyid: any;
  clinic_name: string;
  clinic_id: string;
  clinic: any;
  fb_consent_path: any;

  task: AngularFireUploadTask;

  @ViewChild('sigpad1') signaturePad: SignaturePad; 
  @ViewChild('sigpad2') signaturePad2: SignaturePad;
  @ViewChild(Content)
  content: Content;

  private signaturePadOptions: Object = {
    minWidth: 2,
    canvasWidth: 400,
    canvasHeight: 200,
    backgroundColor: "#ffffff",
    penColor: "#6f6f6f"
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private formBuilder: FormBuilder,
    public firestoreProvider: FirestoreProvider,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    private viewCtrl: ViewController,
    private storage: AngularFireStorage
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });

    this.renewal = this.navParams.data["renewal"];
    if (this.renewal) {
      this.agreement = this.navParams.data["agreement"];
      this.agree = true;

      this.consentsignature = this.agreement["consent_signature"];
      this.consentName = this.agreement["consent_name"];

      this.signature = this.agreement["signature"];
      this.signatoryName = this.agreement["signatory_name"];

      this.laststudyid = this.navParams.data["laststudyid"];
    }
    else {
      this.laststudyid = null;
    }
    console.log("Renewal: ", this.renewal);
    this.clinic = this.navParams.data["clinic"];
    this.doctor = this.navParams.data["doctor"];
    this.patient = this.navParams.data["patient"];
    this.study = this.navParams.data["study"];
    console.log("Study: ", this.study);
    this.signatoryName = this.patient.first_name + " " + this.patient.last_name;
    console.log("Patient Info: ", this.study);

    this.surveyresponse = this.formBuilder.group({
      SYMPTOMS_dryness_grittiness_scratchiness_visit: false,
      SYMPTOMS_dryness_grittiness_scratchiness_past72: false,
      SYMPTOMS_dryness_grittiness_scratchiness_past3: false,

      SYMPTOMS_soreness_irritation_visit: false,
      SYMPTOMS_soreness_irritations_past72: false,
      SYMPTOMS_soreness_irritation_past3: false,

      SYMPTOMS_burning_watering_visit: false,
      SYMPTOMS_burning_watering_past72: false,
      SYMPTOMS_burning_watering_past3: false,

      SYMPTOMS_eyefatigue_visit: false,
      SYMPTOMS_eyefatigue_past72: false,
      SYMPTOMS_eyefatigue_past3: false,

      FREQUENCY_dryness_grittiness_scratchiness: null,
      FREQUENCY_soreness_irritation: null,
      FREQUENCY_burning_watering: null,
      FREQUENCY_eyefatigue: null,

      SEVERITY_dryness_grittiness_scratchiness: null,
      SEVERITY_soreness_irritation: null,
      SEVERITY_burning_watering: null,
      SEVERITY_eyefatigue: null,

      EYEDROPS: null,
      EYEDROPS_FREQUENCY: null
    });
  }

  ionViewDidLoad() {}

  calcScore() {
    this.speedscore =
      Number(
        this.surveyresponse.value.FREQUENCY_dryness_grittiness_scratchiness
      ) +
      Number(this.surveyresponse.value.FREQUENCY_soreness_irritation) +
      Number(this.surveyresponse.value.FREQUENCY_burning_watering) +
      Number(this.surveyresponse.value.FREQUENCY_eyefatigue) +
      Number(
        this.surveyresponse.value.SEVERITY_dryness_grittiness_scratchiness
      ) +
      Number(this.surveyresponse.value.SEVERITY_soreness_irritation) +
      Number(this.surveyresponse.value.SEVERITY_burning_watering) +
      Number(this.surveyresponse.value.SEVERITY_eyefatigue);
    console.log("Speed Score: ", this.speedscore);
  }

  consent() {
    console.log("CN: ", this.consentName)
    console.log("SN: ", this.signatoryName)
    if (this.signaturePad.isEmpty() || this.signaturePad2.isEmpty() || this.consentName === null || this.signatoryName === null) {
      let alert = this.alertCtrl.create({
        title: "Consent Problem",
        subTitle: "You must add a signature and / or complete the full consent before completing the study",
        buttons: ["OK"]
      });
      alert.present();
    } else {

      let loading = this.loadingCtrl.create();
      loading.present();
  
      this.createConsentPDF().then((path) => {
        this.fb_consent_path = path;
        this.agree = true;
        this.saveSignature();
        this.content.scrollToTop();
        loading.dismiss();
      })
      .catch((error) => {
        loading.dismiss();
      });

    }
  }

  saveSurvey(): void {
    let confirm = this.alertCtrl.create({
      title: "Save Study",
      message:
        "Are you ready to save your study results?  If you select yes, after saving you will be redirected back to the order view to complete your order.",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't save study");
          }
        },
        {
          text: "Yes",
          handler: () => {
            /*******SAVE STUDY RESULTS ************************/

            this.completeStudy(true);
            /*
            this.database
              .createStudy(
                this.clinic_id,
                this.patient.id,
                studyresult,
                this.laststudyid
              )
              .then(
                data => {
  
                    loading.dismiss().then(() => {
                      this.viewCtrl.dismiss(studyresult);
                    });
                },
                error => {
                  loading.dismiss().then(() => {
                    const alert: Alert = this.alertCtrl.create({
                      message: error.message,
                      buttons: [{ text: "Ok", role: "cancel" }]
                    });
                    alert.present();
                  });
                }
              );
              */

          }
        }
      ]
    });
    confirm.present();
  }

  hiddenClone(element) {
    var clone = element.cloneNode(true);
    var style = clone.style;
    style.position = 'relative';
    style.top = window.innerHeight + 'px';
    style.left = 0;
    style.width = 1200 + 'px';
    document.body.appendChild(clone);
    return clone;
  }

  createConsentPDF() {
    return new Promise((resolve, reject) => {
      this.saveSignature();
      let el = document.getElementById('consent');
      let clone = this.hiddenClone(el);

      let patient_img = document.createElement("img");
      patient_img.style.borderBottom = '1px dashed black';
      patient_img.width = 200;
      patient_img.height = 100;
      patient_img.src = this.signature;
      let patient_name = document.createElement("div");
      patient_name.style.fontSize = '14px';
      patient_name.innerText = 'Patient: ' + this.signatoryName

      let consent_img = document.createElement("img");
      consent_img.style.borderBottom = '1px dashed black';
      consent_img.width = 200;
      consent_img.height = 100;
      consent_img.src = this.consentsignature;
      let consent_name = document.createElement("div");
      consent_name.style.fontSize = '14px';
      consent_name.innerText = 'Person Obtaining Consent: ' + this.consentName;

      let table = document.createElement("table");
      let tr = document.createElement("tr");
      let ltd = document.createElement("td");
      ltd.style.width = '250px';
      ltd.appendChild(patient_img);
      ltd.appendChild(patient_name);

      let rtd = document.createElement("td");
      rtd.style.width = '250px';
      rtd.appendChild(consent_img);
      rtd.appendChild(consent_name);

      tr.appendChild(ltd);
      tr.appendChild(rtd);
      table.appendChild(tr);
      clone.appendChild(table)
      
      let date_div = document.createElement("div");
      date_div.style.fontSize = '14px';
      date_div.innerText = (new Date().toLocaleString());
      clone.appendChild(date_div);

      html2canvas(clone, { width: 1200, background: 'white'}).then((canvas) => {
          var ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = false;
          let img = canvas.toDataURL("image/png", 0.5);
          let doc = new jsPDF('p', 'px', 'letter');
          var height = doc.internal.pageSize.getHeight()-30;
          let width = height * .7;
          doc.addImage(img , 30, 10, width, height);
          this.uploadConsenttoFirebase(doc.output("blob")).then((path) => {
            resolve(path);
          });
          document.body.removeChild(clone);

      }).catch(error => {
        console.log('Error creating PDF: ', error);
        reject(null);
      })
    });
  }

  completeStudy(isComplete: boolean) {
    let studyresult = {};
      studyresult = this.surveyresponse.value;
      studyresult['consent_agreement'] = this.fb_consent_path;
      studyresult['study_id_last'] = this.laststudyid;
      studyresult['clinic_id'] = this.clinic_id;
      studyresult['clinic_name'] = this.clinic_name;
      studyresult['doctor_id'] = this.doctor.id
      studyresult['patient_id'] = this.patient.id
      studyresult['Renewed'] = false;
      studyresult['speedscore'] = this.speedscore;
      studyresult['agreement'] = {
        'signatory_name': this.signatoryName,
        'signature': this.signature,
        'consent_name': this.consentName,
        'consent_signature': this.consentsignature
      }
      studyresult['doctor'] = this.doctor;
      studyresult['patient'] = this.patient;
      studyresult['study'] = this.study;
      studyresult['completed'] = isComplete;
      if(isComplete)  {
        studyresult['_status'] = 'enrolled';
      }
      else {
        studyresult['_status'] = 'notenrolled';
      }

      this.viewCtrl.dismiss(studyresult);

  }

  cancelModal()  {
    this.completeStudy(false);
  }

  clearPad() {
    this.signaturePad.clear();
  }

  saveSignature() {
    this.signature = this.signaturePad.toDataURL();
    this.consentsignature = this.signaturePad2.toDataURL();
  }

  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }

  clearPad2() {
    this.signaturePad2.clear();
  }

  drawComplete2() {
    this.isDrawing = false;
  }

  drawStart2() {
    this.isDrawing = true;
  }

  uploadConsenttoFirebase(file: any): any {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      filePath = `study_consent/${this.clinic_name}_${this.patient.last_name}_${new Date().getTime()}.pdf`;
  
      console.log("File Path: ", filePath);
      this.task = this.storage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          resolve(u);
          console.log("File Upload Complete: ", file); 
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/survey.ts